import React, { useContext } from "react";
import studentImage from "../../assets/student_portal.png";

import useUserStore from "../../stores/useUserStores";

interface FeatureCardProps {
  title: string;
  description: string;
  buttonText: string;
  bgColor: string;
  textColor: string;
  buttonColor: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  buttonText,
  bgColor,
  textColor,
  buttonColor,
}) => {
  const { islogin, userdetail, isAdmin } = useUserStore();

  return (
    <div
      className={`rounded-lg shadow-sm bg-gradient-to-r pt-4 md:pt-8 from-blue-100 to-indigo-300 border border-indigo-200 px-4 w-full`}
    >
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex-1 md:w-2/3 flex flex-col justify-center z-10 order-2 md:order-1 text-center md:text-left py-4 md:py-0">
          <h2 className="text-xl sm:text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-2">
            Welcome Back,{" "}
            <span className="text-blue-600">
              {userdetail?.fullName || "User"}
            </span>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-sm lg:text-lg font-medium mb-4 md:mb-6">
            Stay updated with your Candidate Portal
          </p>
        </div>
        <div className="order-1 md:order-2 w-full md:w-auto flex justify-center">
          <img
            src={studentImage}
            alt="Student portal"
            className="w-[200px] h-auto sm:w-[300px] sm:h-48 md:w-[350px] md:h-56 lg:w-[400px] lg:h-64"
          />
        </div>
      </div>
    </div>
  );
};
